<template>
  <div>
    <transition name="route" mode="out-in">
      <PreLoader v-if="allIsLoading" />
    </transition>
    <div class="container">
      <div class="contact-section">
        <div class="left-content col-xs-12 col-md-6">
          <span
            ><img
              class="contact-us-icon"
              :src="this.publicPath+'assets/images/contactusIcon.png'"
              alt=""
          /></span>
          <h1 class="title">Contact Us</h1>
          <h4 class="subtitle">
            For those involved in the fields of operation, retail, or platform
            provision.
          </h4>
          <p class="info">
            If you are keen on incorporating our exceptional content, Contact
            us!
          </p>
        </div>
        <div class="right-content col-xs-12 col-md-6">
          <div class="contact-form">
            <form @submit.prevent="submitForm">
              <div class="input-field">
                <label for="sendername">Name*</label>
                <input
                  id="sendername"
                  type="text"
                  v-model="formData.sendername"
                />
              </div>
              <div class="input-field-row">
                <div
                  class="input-field"
                  :class="{
                    'col-xs-12': isSmallScreen,
                    'col-md-6': !isSmallScreen,
                  }"
                >
                  <label for="email">Email*</label>
                  <input
                    id="email"
                    type="email"
                    v-model="formData.email"
                    @input="validateEmail"
                  />
                </div>
                <div
                  class="input-field"
                  :class="{
                    'col-xs-12': isSmallScreen,
                    'col-md-6': !isSmallScreen,
                  }"
                >
                  <label for="phone">Telephone Number*</label>
                  <input
                    id="phone"
                    type="tel"
                    v-model="formData.phone"
                    @input="validatePhoneNumber"
                  />
                </div>
              </div>
              <div class="input-field-row">
                <div
                  class="input-field"
                  :class="{
                    'col-xs-12': isSmallScreen,
                    'col-md-6': !isSmallScreen,
                  }"
                >
                  <label for="company">Company*</label>
                  <input id="company" type="text" v-model="formData.company" />
                </div>
                <div
                  class="input-field"
                  :class="{
                    'col-xs-12': isSmallScreen,
                    'col-md-6': !isSmallScreen,
                  }"
                >
                  <label for="department">Department*</label>
                  <select id="department" v-model="formData.department">
                    <option value="" disabled class="text-left">
                      Choose an option
                    </option>
                    <option value="Sales">Sales</option>
                    <option value="PR">PR</option>
                    <option value="HR">HR</option>
                    <option value="Legal">Legal</option>
                    <option value="FInance">Finance</option>
                  </select>
                </div>
              </div>
              <div class="input-field">
                <label for="message">Your message*</label>
                <textarea
                  id="message"
                  rows="6"
                  v-model="formData.message"
                ></textarea>
              </div>
              <div class="input-field">
                <p class="field-disclaimer">
                  By clicking 'Submit,' you consent to The New EAR S.r.l.
                  processing your personal data so that they can contact you.
                  Learn more about how The New EAR S.r.l. processes your
                  personal data by reviewing the Privacy Policy.
                </p>
              </div>
              <div class="input-field">
                <button @click="submitForm" class="btn-submit">Send</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import PreLoader from "@/components/Global/PreLoader.vue";
export default {
  name: "App",
  components: {
    PreLoader,
  },
  data() {
    return {
      isSmallScreen: window.innerWidth <= 992,
      allIsLoading: true,
      isEmailValid: false,
      isPhoneNumberValid: false,
      publicPath:process.env.VUE_APP_PUBLIC_PATH ?? "/",
      formData: {
        sendername: "",
        email: "",
        phone: "",
        company: "",
        department: "",
        message: "",
      },
      lang: localStorage.getItem("language") ?? "en",
    };
  },
  created() {
    let lang = localStorage.getItem("language") ?? "en";
    this.$router.push({ params: { lang: lang } });
    this.timeout();
    this.setMetaTags();
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.isSmallScreen = window.innerWidth <= 992;
    });
  },
  methods: {
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.isEmailValid = emailRegex.test(this.formData.email);
    },
    validatePhoneNumber() {
      const phoneRegex = /^\d{1,15}$/; // Allows between 1 and 15 digits
      this.isPhoneNumberValid = phoneRegex.test(this.formData.phone);
    },
    submitForm() {
      if (this.isPhoneNumberValid && this.isEmailValid) {
        if (
          this.formData.sendername.trim() !== "" &&
          this.formData.email.trim() !== "" &&
          this.formData.phone.trim() !== "" &&
          this.formData.company.trim() !== "" &&
          this.formData.department.trim() !== "" &&
          this.formData.message.trim() !== ""
        ) {
          this.$store
            .dispatch("Notifications/sendFormContact", {
              name: this.formData.sendername,
              email: this.formData.email,
              telephone: this.formData.phone,
              company: this.formData.company,
              department: this.formData.department,
              message_body: this.formData.message,
            })
            .then(() => {
              // Notifica di conferma dopo l'invio dell'email
              Swal.fire({
                title: "Success",
                text: "Your message has been sent successfully!",
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
                showCancelButton: false,
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                willClose: () => {
                  location.reload();
                },
              });
            })
            .catch((error) => {
              console.error("Error sending email:", error);
              // Gestione degli errori, se necessario
            });
        } else {
          Swal.fire({
            title: "Attention",
            text: "You must fill all fields",
            icon: "warning",
            showCancelButton: true,
            allowOutsideClick: false,
          });
        }
      } else {
        if (!this.isPhoneNumberValid) {
          Swal.fire({
            title: "Attention",
            text: "You must insert a valid Phone Number",
            icon: "warning",
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "Ok",
            cancelButtonColor: "red",
            allowOutsideClick: false,
          });
        } else if (!this.isEmailValid) {
          Swal.fire({
            title: "Attention",
            text: "You must insert a valid E-mail address",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: "Ok",
            showConfirmButton: false,
            cancelButtonColor: "red",
            allowOutsideClick: false,
          });
        }
      }
    },
    timeout() {
      document.body.style.overflow='hidden';
      document.documentElement.style.overflow='hidden';
      setTimeout(() => {
        document.body.style.overflow='';
        document.documentElement.style.overflow='';
        this.allIsLoading = false;
      }, 1500);
    },
    setMetaTags() {
      const title = "The Ear | Contact us";
      const metaDescription =
        "Get in Touch with Us – Your Gateway to Seamless Communication.";

      document.title = title;

      const metaDescriptionTag = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.setAttribute("content", metaDescription);
      } else {
        const newMetaTag = document.createElement("meta");
        newMetaTag.name = "description";
        newMetaTag.content = metaDescription;
        document.head.appendChild(newMetaTag);
      }
    },
  },
};
</script>

<style scoped>
.container {
  padding: 160px 0px 75px;
  display: flex;
  justify-content: space-around;
}
.contact-section {
  display: flex;
  justify-content: space-between;
  text-align: center;
}

.title {
  font-family: "Montserrat", sans-serif;
  font-size: 50px;
  font-weight: 700 !important;
  text-align: left;
  text-transform: uppercase;
  color: #000;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 18px;
  font-weight: 600;
  /* text-align: left; */
  text-align: center;
  color: #737986;
  margin: 5px 0px;
}

.info {
  font-size: 14px;
  color: #000;
  font-weight: 600;
  line-height: 1.57;
  text-align: left;
  margin: 5px 0px;
}

.field-disclaimer {
  display: block;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 700;
  opacity: 0.7;
  margin-bottom: 10px;
}

.left-content {
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 0px 20px;
}

.left-content .contact-us-icon {
  max-width: 100px;
  max-height: 100px;
  object-fit: contain;
}

.right-content {
  padding: 45px 60px 60px;
  border: none;
  border-radius: 10px;
  box-shadow: -2px 0px 10px 8px lightgray;
}

.input-field {
  margin: 15px -10px;
  text-align: left;
}

input:focus {
  outline: 2px solid cornflowerblue;
}

select:focus {
  outline: 2px solid cornflowerblue;
}

textarea:focus {
  outline: 2px solid cornflowerblue;
}

.input-field-row {
  display: flex;
  justify-content: space-between;
}

label {
  text-align: left;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  color: #626985;
  margin-bottom: 10px;
}

input[type="text"],
input[type="email"],
input[type="tel"],
select,
textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.btn-submit {
  background-color: #007bff;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  max-width: 300px;
  transition: 0.3s all;
}

.btn-submit:hover {
  background-color: #0056b3;
  transition: 0.3s all;
}

@media screen and (max-width: 992px) {
  .container {
    padding: 100px 20px 75px;
    display: flex;
    justify-content: space-around;
  }
  .contact-section {
    flex-direction: column;
    width: 100%;
    padding: 0px 10px 0px;
  }

  .title {
    font-family: "Montserrat", sans-serif;
    font-size: 35px;
    font-weight: 700 !important;
    text-align: left;
    text-transform: uppercase;
    color: #000;
    margin-bottom: 10px;
  }
  .subtitle {
    font-size: 18px;
    font-weight: 600;
    /* text-align: left; */
    text-align: center;
    color: #737986;
    margin: 10px 0px;
  }
  .info {
    font-size: 14px;
    color: #000;
    font-weight: 600;
    line-height: 1.57;
    text-align: center;
    margin: 10px 0px;
  }

  .left-content,
  .right-content {
    flex: 1;
    width: 100%;
  }

  .right-content {
    padding: 20px 30px 20px;
    border: none;
    border-radius: 10px;
    box-shadow: -2px 0px 10px 8px lightgray;
  }

  .left-content {
    padding: 25px 0px 25px;
    margin: 0px 0px;
  }
  .input-field-row {
    flex-direction: column;
  }

  #sendername,
  #email,
  #phone,
  #company,
  #department {
    width: 100%;
  }
}
</style>
